function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { COMMON, LAYOUT, get } from '../constants';
import theme from '../theme';
import sx from '../sx';
import { XIcon } from '@primer/octicons-react';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const StyledButton = styled.button.withConfig({
  displayName: "ButtonClose__StyledButton",
  componentId: "sc-10mogoy-0"
})(["border:none;padding:0;background:transparent;outline:none;cursor:pointer;&:focus{box-shadow:", ";}&:active{color:", ";}", ";", ";", ";"], get('buttons.close.shadow.focus'), get('buttons.close.color.default'), COMMON, LAYOUT, sx);
const ButtonClose = forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    ref: ref,
    "aria-label": "Close"
  }, props), /*#__PURE__*/React.createElement(XIcon, null));
});
ButtonClose.defaultProps = {
  theme
};
ButtonClose.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  ...COMMON.propTypes,
  ...LAYOUT.propTypes,
  ...sx.propTypes
};
export default ButtonClose;